import { useTranslation } from "../../../hooks/useTranslation";
import { SOLUTION_TYPES } from "../../layout/footer/contact";
import styles from "./index.module.scss";

type RadioProps = {
    value : SOLUTION_TYPES;
    checked: boolean;
    onChange: () => void;
};

export const Radio = (props: RadioProps) => {
    const { t } = useTranslation();
    
    return (
        <label className={styles.pill + (props.checked ? ' ' + styles.selected : '')}>
            <input
                type="radio"
                value={props.value}
                checked={props.checked}
                onChange={props.onChange}
                required
                className={styles.input}
            />
            <p>{t("global."+props.value)}</p>
        </label>
    );
};